module.exports = __webpack_public_path__ + "static/keyword-suggestions-6c41cc5b5e970612b1c586f2558325b9.jpg";